<template lang="pug">
#login.section
  .columns
    .column.is-one-third.is-offset-one-third
      .login-form.box
        .has-text-centered
          h4.is-size-4 Welcome Back
        form(@submit.prevent="submit" novalidate)
          b-field(
            label="Email"
            :type="errors.has('email') ? 'is-danger' : ''"
            :message="errors.has('email') ? errors.first('email') : ''"
          )
            b-input(v-model="credentials.email" name="email" v-validate="'required'")
          b-field(
            label="Password"
            :type="errors.has('password') ? 'is-danger' : ''"
            :message="errors.has('password') ? errors.first('password') : ''"
          )
            b-input(type="password" name="password" v-model="credentials.password" v-validate="'required'" password-reveal)
          .buttons
            button.button.is-primary(
              type="submit"
              :class="{ 'is-loading': settings.submitting }"
            ) Login
            router-link.button.is-text.has-text-primary(:to="{ name: 'passwordReset' }") Forgot password?
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      authenticated: getters.GET_AUTHENTICATED_USER,
      pages: getters.GET_APP_PAGES,
    }),
  },
  data() {
    return {
      credentials: {},
      error: {
        message: null,
        active: false,
      },
      settings: {
        submitting: false,
      },
    };
  },
  methods: {
    async submit() {
      const result = await this.$validator.validateAll();
      if (result) {
        this.settings.submitting = true;
        try {
          await this.$store.dispatch(actions.DO_LOGIN, this.credentials);
          await this.$store.dispatch(actions.DO_GET_AUTHENTICATED_USER);
          this.settings.submitting = false;
          const filtered = _.filter(this.pages, page => this.authenticated.access[page]);
          if (filtered.length > 0) {
            this.$router.push({ name: filtered[0] });
          } else {
            this.$store.commit(mutations.SET_APP_SNACKBAR, {
              type: 'is-danger',
              message: 'Account access disabled',
            });
          }
        } catch (error) {
          this.settings.submitting = false;
          this.$store.commit(mutations.SET_APP_SNACKBAR, {
            type: 'is-danger',
            message: error.response.data.data.error_message,
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
#login {
  height: 100vh;
  background-image: url('/static/bg.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  .login-form {
    margin-top: 80px;
  }
  .buttons {
    margin-top: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue